import React, { PropTypes as T } from 'react';
import cn from 'classnames';
import Button from '../../common/button';
import ClearIcon from '../../common/icons/icon_clear';
import ValidIcon from '../../common/icons/icon_modal_success';
import ErrorIcon from '../../common/icons/icon_modal_caution';

export default class InputText extends React.Component {
  static propTypes = {
    type: T.string,
    onChange: T.func,
    onBlur: T.func,
    value: T.any,
    disabled: T.bool,
    flex: T.bool,
    inline: T.bool,
    className: T.string,
    style: T.object,
    dataComponent: T.string,
    stateValid: T.bool,
    stateError: T.bool,
    clearable: T.bool,
    hintMessage: T.string,
    errorMessage: T.string
  };

  static defaultProps = {
    type: 'text',
    value: '',
    hintMessage: '',
    errorMessage: '',
    style: {},
    clearable: true,
    disabled: false,
    stateValid: false,
    stateError: false,
    onChange: Function.prototype,
    onBlur: Function.prototype
  };

  state = {
    value: this.props.value,
    stateValid: this.props.stateValid,
    stateError: this.props.stateError
  };

  componentWillReceiveProps (nextProps) {
    if (
      nextProps.stateValid !== this.state.stateValid ||
      nextProps.stateError !== this.state.stateError
    ) {
      this.setState({
        stateValid: nextProps.stateValid,
        stateError: nextProps.stateError
      });
    }
    if (nextProps.value !== this.state.value) {
      this.setState({
        stateValid: false,
        stateError: false,
        value: nextProps.value
      });
    }
  }

  change = e => {
    this.setState(
      {
        value: e.target.value,
        stateValid: false,
        stateError: false
      },
      () => this.props.onChange(this.state.value)
    );
  };

  blur = e => {
    this.props.onBlur(e.target.value);
  };

  clear = () => {
    this.setState({ value: '', stateValid: false, stateError: false }, () =>
      this.props.onChange(this.state.value)
    );
    this.input.focus();
  };

  render () {
    const {
      disabled,
      type,
      flex,
      inline,
      className,
      dataComponent,
      clearable,
      hintMessage,
      errorMessage,
      style,
      stateValid,
      stateError,
      onSumbit,
      ...rest
    } = this.props;
    const classNames = cn({
      cInputText: true,
      'cInputText--disabled': disabled,
      'cInputText--flex': flex,
      'cInputText--inline': inline,
      'cInputText--stateValid': this.state.stateValid,
      'cInputText--stateError': this.state.stateError,
      [className]: className
    });

    return (
      <div className={classNames} data-component={dataComponent} style={style}>
        {clearable &&
          !disabled &&
          !this.state.stateValid &&
          !this.state.stateError &&
          this.state.value &&
          this.state.value.length > 0 &&
          <Button
            icon
            onClick={this.clear}
            className="cInputText__buttons"
            data-component="clear-input-button"
          >
            <ClearIcon className="cInputText__icon--clear" width={18} />
          </Button>}
        <input
          {...rest}
          type={type}
          value={this.state.value}
          onChange={this.change}
          onBlur={this.blur}
          disabled={disabled}
          className="cInputText__input"
          ref={ref => {
            this.input = ref;
          }}
        />
        {this.state.stateValid &&
          <Button icon nonInteractive className="cInputText__buttons">
            <ValidIcon className="cInputText__icon--valid" width={18} />
          </Button>}
        {this.state.stateError &&
          <Button icon nonInteractive className="cInputText__buttons">
            <ErrorIcon className="cInputText__icon--error" width={18} />
          </Button>}
        {((hintMessage && hintMessage.length > 0) ||
          (errorMessage && errorMessage.length > 0)) &&
          <div className="cInputText__info">
            {hintMessage.length > 0 &&
              <div className="cInputText__info--hint">{hintMessage}</div>}
            {errorMessage.length > 0 &&
              <div className="cInputText__info--error">{errorMessage}</div>}
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/input_text/input_text.js